<template>
  <div>
    <Header :title="'文章管理'" />

    <ul>
      <li class="edit-title">
        <div class="bold">文章标题</div>
        <nut-textbox
          v-model="title"
          :limit-show="false"
          :txt-area-h="20"
          :max-num="20"
          :switch-max="true"
        />
      </li>
      <li class="edit-content">
        <div class="bold">内容</div>
        <vue-editor v-model="content" :editor-toolbar="customToolbar" />
      </li>
      <li class="edit-isComment">
        <div class="bold">是否允许评论</div>
        <nut-radiogroup v-model="isComment">
          <nut-radio label="true">允许</nut-radio>
          <nut-radio label="false">不允许</nut-radio>
        </nut-radiogroup>
      </li>
    </ul>
    <div v-show="hideShow" style="height: 65px" />
    <div v-show="hideShow" class="btn-create bold" @click="createArticle">发表文章</div>
  </div>
</template>

<script>
import { Toast } from '@nutui/nutui'
import { createHallArticle } from '@/api/Personal/Hall'
import { CheckPower } from '@/api/Hall'
import Header from '@/components/Header/Index'
import { VueEditor } from 'vue2-editor'

export default {
  name: 'Create',
  components: {
    Header,
    VueEditor
  },
  data() {
    return {
      id: 0,
      name: '',
      title: '',
      content: '',
      isComment: 'true',
      docHeight: document.documentElement.clientHeight || document.body.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight || document.body.clientHeight, // 实时屏幕高度
      hideShow: true,
      power: 0,
      isPreview: false,
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{
          color: []
        }, {
          background: []
        }],
        [{
          align: ''
        }, {
          align: 'center'
        }, {
          align: 'right'
        }, {
          align: 'justify'
        }], ['clean']
      ]
    }
  },
  computed: {
    data() {
      return {
        hallId: this.id,
        title: this.title,
        content: this.content,
        isComment: this.isComment === 'true'
      }
    }
  },
  watch: {
    showHeight() {
      this.hideShow = this.docHeight <= this.showHeight
    }
  },
  created() {
    this.id = this.$route.params.id
    this.judgePower()
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.showHeight = document.documentElement.clientHeight || document.body.clientHeight
      })()
    }
  },
  methods: {
    judgePower() {
      CheckPower(this.id).then(res => {
        if (res.data.desc === '请先登录') {
          this.power = 1
        }
        if (res.data.desc === '没有权限') {
          this.power = 2
        }
        if (res.data.desc === '有权限') {
          this.power = 3
        }
      })
    },
    cancel() {
      this.$router.back()
    },
    createArticle() {
      if (this.title !== '' && this.content !== '') {
        createHallArticle(this.data).then(res => {
          if (res.success) {
            if (this.power === 3) {
              Toast.success('发表成功', {
                duration: 500
              })
            } else if (this.power === 2) {
              Toast.success('发表成功，请耐心等待审核', {
                duration: 500
              })
            }
            setTimeout(() => {
              this.$router.back()
            }, 500)
          } else {
            Toast.fail('发表失败')
          }
        })
      } else {
        Toast.fail('有空项')
      }
    },
    togglePreview() {
      this.isPreview = !this.isPreview
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  margin: 0 15px;

  li {
    padding-top: 15px;

    > div:first-child {
      margin-bottom: 5px;
    }
  }
}

.edit-content {
  ::v-deep .quillWrapper {
    background-color: #fff;

    .ql-toolbar {
      border-radius: 5px 5px 0 0;
      border-color: #ececee;
      padding: 5px;

      .ql-formats {
        margin-bottom: 5px;
        margin-right: 5px;

        button {
          width: 7vw;
          padding: 0.8vw 1.3vw;
        }

        svg {
          width: 5.8vw !important;
          height: 5.8vw !important;
        }
      }
    }

    .ql-container.ql-snow {
      border-radius: 0 0 5px 5px;
      border-color: #ececee;
      height: 300px;
      overflow: hidden;
      font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC',
      'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
    }
  }
}

.nut-textbox {

  ::v-deep .txt-area {
    font-size: 14px;
    border-radius: 5px;
    overflow: hidden;
  }

  ::v-deep .txt-area.error {
    border: 1px solid $primary-color-bright;

    span {
      color: $primary-color-bright;
    }
  }
}

.edit-isComment {
  display: flex;

  .nut-radiogroup {
    flex: 1;
    display: flex;
    justify-content: space-evenly;

    ::v-deep .nut-radio-ani {
      background-image: none;
      background-color: #fff;
      border-width: 5px;
    }

    ::v-deep input:checked {
      border-color: #f9bc38;
    }

    ::v-deep input::after {
      background: $primary-color;
    }
  }
}

.btn-create {
  position: fixed;
  bottom: 0;
  width: 100vw;
  height: 50px;
  line-height: 50px;
  text-align: center;
  letter-spacing: 5px;
  text-indent: 5px;
  color: #fff;
  background-color: $primary-color;
}
</style>
